import './App.css';
import NavBar from './components/NavBar';
import Home from './components/pages/Home';
import AboutMe from './components/pages/AboutMe';
import Experiences from './components/pages/Experiences';
import Projects from './components/pages/Projects';
import Skills from './components/pages/Skills';
import Studies from './components/pages/Studies';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
//import Contact from './components/pages/Contact';


function App() {

  const location = useLocation();

  useEffect(() => {
    if (location.hash) 
    {
      let elem = document.getElementById(location.hash.slice(1))
      if (elem) elem.scrollIntoView({ behavior: 'smooth' })
    }
  }, [location,])

  return (
    <div>
      <NavBar/>
      <Home id="home"/>
      <AboutMe id="about-me"/>
      <Skills id="skills"/>
      <Projects id="projects"/>
      <Experiences id="experiences"/>
      <Studies id="studies"/>
      {/*<Contact id="contact"/>*/}
    </div>
  );
}

export default App;
